import React from 'react';

// ════════════════════════════════════════════════════════════════════
// Salvavidas
//
// Cuando una pantalla falla, React desmonta TODA la aplicación y deja
// la ventana en blanco. Eso fue lo que pasó al eliminar un documento:
// un aviso con un tipo que no existía tumbó todo.
//
// Esto atrapa el fallo y muestra algo con lo que se puede seguir
// trabajando. Un error mal pintado es un detalle; una pantalla en
// blanco deja a alguien tirado en obra sin saber qué hacer.
// ════════════════════════════════════════════════════════════════════

export class Salvavidas extends React.Component {
  constructor(props) {
    super(props);
    this.state = { fallo: null };
  }

  static getDerivedStateFromError(fallo) {
    return { fallo };
  }

  componentDidCatch(fallo, info) {
    // Queda en la consola del navegador para poder diagnosticarlo
    console.error('[rinde] pantalla caída:', fallo, info?.componentStack);
  }

  render() {
    if (!this.state.fallo) return this.props.children;

    return (
      <div style={{
        maxWidth: 520, margin: '40px auto', padding: '24px 20px',
        fontFamily: 'system-ui, -apple-system, sans-serif', color: '#141922',
      }}>
        <div style={{
          fontSize: 22, fontWeight: 700, color: '#0D2547', marginBottom: 10,
        }}>
          Esta pantalla falló
        </div>

        <div style={{ fontSize: 14, lineHeight: 1.6, marginBottom: 20 }}>
          Lo que estabas haciendo no se perdió: los datos ya guardados están
          a salvo. Vuelve al panel y sigue desde ahí.
        </div>

        <div style={{ display: 'flex', gap: 9, flexWrap: 'wrap' }}>
          <button
            onClick={() => { window.location.hash = ''; window.location.reload(); }}
            style={{
              background: '#B8841C', color: '#0D2547', border: 'none',
              padding: '11px 18px', borderRadius: 8, fontSize: 14,
              fontWeight: 600, cursor: 'pointer',
            }}>
            Volver al panel
          </button>
          <button
            onClick={() => this.setState({ fallo: null })}
            style={{
              background: '#fff', color: '#141922', border: '1px solid #DDDCD6',
              padding: '11px 18px', borderRadius: 8, fontSize: 14,
              fontWeight: 600, cursor: 'pointer',
            }}>
            Intentar de nuevo
          </button>
        </div>

        <details style={{ marginTop: 22, fontSize: 12, color: '#6B7280' }}>
          <summary style={{ cursor: 'pointer' }}>Detalle técnico</summary>
          <pre style={{
            marginTop: 9, padding: 11, background: '#F2F1ED', borderRadius: 6,
            fontSize: 11, overflowX: 'auto', whiteSpace: 'pre-wrap',
          }}>
            {String(this.state.fallo?.message || this.state.fallo)}
          </pre>
        </details>
      </div>
    );
  }
}
